module.exports = __webpack_public_path__ + "static/media/2 (36).6a11f0f5.jpg";